export const ARTICLE_FETCH_REQUEST = 'ARTICLE_FETCH_REQUEST';
export const ARTICLE_FETCH_FAILURE = 'ARTICLE_FETCH_FAILURE';
export const ARTICLE_FETCH_SUCCESS = 'ARTICLE_FETCH_SUCCESS';
export const RATE_ARTICLE_REQUEST = 'RATE_ARTICLE_REQUEST';
export const LIKE_ARTICLE_SUCCESS = 'LIKE_ARTICLE';
export const DISLIKE_ARTICLE_SUCCESS = 'DISLIKE_ARTICLE';